import { IgButton } from "@intelligems/ig-theme";
import { IgAppBanner } from "@src/components/Utils/IgAppBanner";
import { useDialogs } from "@src/hooks/dialog";

import { RecheckButton } from "./RecheckButton";
import { OrgIdProp, VariantProp } from "./types";

/**
 * Alert shown when the script is outdated (CJS) and user is on /events-manager.
 * Route gating is handled by the alert system in types.ts (computeRawAlerts).
 */
export const CustomEventsEsmAlert = ({
  orgId,
  additionalAlert,
  endContent,
}: OrgIdProp & VariantProp) => {
  const { openDialog } = useDialogs();

  return (
    <IgAppBanner
      dismissId="custom-events-esm-alert"
      title="Custom Events require a newer script."
      message="Update script for compatibility and latest improvements."
      variant={additionalAlert ? "secondary" : "info"}
      buttons={[
        <RecheckButton
          key="recheck"
          orgId={orgId}
          additionalAlert={additionalAlert}
        />,
        <IgButton
          key="update"
          size="extraSmall"
          variant="contained"
          color={additionalAlert ? "primary" : "secondary"}
          onClick={() => openDialog("scriptTag")}
        >
          Update Intelligems
        </IgButton>,
      ]}
      endContent={endContent}
    />
  );
};
